export { CourseSkeleton } from "./CourseSkeleton";
